import axios from "../plugins/parseAxios";
export class ProjectAPI {
  constructor(props) { }
  static getProject(payload) {
    return axios.post("functions/getProject", payload);
  }
}
